import { useState } from 'react';
import getUserPreferredLanguage from './i18n/getUserPreferredLanguage';
import { resetCache } from './i18n/messageCache';
import useUserProfile from './useUserProfile';

const useAuthenticatedRouteLanguage = () => {
    const [userProfile] = useUserProfile();

    const initialLanguageValue = userProfile?.language ?? getUserPreferredLanguage();

    const [messageLanguage, setMessageLanguage] = useState(initialLanguageValue);

    const handleMessageLanguageChange = (newValue) => {
        if (newValue !== messageLanguage) {
            resetCache();
            setMessageLanguage(newValue);
        }
    };

    return [messageLanguage, handleMessageLanguageChange];
};

export default useAuthenticatedRouteLanguage;
